import { connect, MapStateToProps } from 'react-redux';
import { Props } from './FaqBlock';
import { getFaqs } from '../../../../redux/packagePicker/selectors';

export type StateProps = Pick<Props, 'faqs'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  faqs: getFaqs(state) || [],
});

export default connect(mapStateToProps);
